import './index.scss';

import imgcredito5 from '../../../../../assets/images/para-sua-empresa/img-credito/img-credito5@2x.png';

export const FINIMP = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> FINIMP - Financiamento à importação </h1>

                <p>
                    Existem diversas modalidades de financiamento à importação, cada uma
                    com suas características, vantagens e desvantagens. A escolha da melhor
                    opção depende das necessidades específicas de cada importador, como o
                    prazo de pagamento, o valor da importação e a relação com o fornecedor.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    1. Financiamento por meio de bancos:
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Pré-embarque: </span>
                    Financiamento concedido ao exportador para a produção ou
                    aquisição da mercadoria a ser exportada. O importador, neste caso, garante
                    o pagamento ao banco financiador.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>  Pós-embarque: </span>
                    Financiamento concedido ao importador para o pagamento
                    da mercadoria após o embarque. Este tipo de financiamento pode ser
                    feito através de linhas de crédito, adiantamento de contrato de câmbio (ACC) ou
                    carta de crédito.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    2. Financiamento pelo fornecedor (credito de fornecedores):
                </p>

                <p>
                    O fornecedor concede um prazo de pagamento ao importador, permitindo
                    que ele pague a mercadoria após o recebimento. Essa modalidade é
                    comum em relações comerciais consolidadas e pode ser uma opção mais
                    barata do que o financiamento bancário.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    3. Financiamento por meio de agências de crédito à exportação (ACE):
                </p>

                <p>
                    As ACEs são instituições governamentais ou privadas que oferecem
                    financiamento e seguro para exportações e importações. Elas visam
                    promover o comércio exterior e apoiar as empresas nacionais.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    4. Factoring:
                </p>

                <p>
                    O importador vende seus direitos creditórios (recebíveis) a uma factoring,
                    que antecipa o pagamento ao fornecedor. Essa modalidade pode ser útil
                    para importadores que precisam de recursos imediatos e têm recebíveis a
                    longo prazo.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    5. Leasing internacional:
                </p>

                <p>
                    Arrendamento de equipamentos ou máquinas importadas. O importador
                    paga parcelas periódicas pelo uso do bem, sem precisar desembolsar o valor
                    total da compra.
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgcredito5} src={imgcredito5} />
                <div>
                    <h1> Vantagens </h1>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Preservação do capital de giro: </span>
                        O financiamento permite
                        que o importador não utilize seus recursos próprios para
                        pagar a importação, preservando seu capital de giro para
                        outras atividades, como investimentos, expansão ou
                        pagamento de despesas operacionais.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Flexibilidade de pagamento: </span>
                        As diferentes modalidades
                        de financiamento oferecem prazos e condições de
                        pagamento flexíveis, permitindo que o importador se
                        adapte ao seu fluxo de caixa e negocie melhores condições
                        com o fornecedor.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Competitividade: </span>
                        O acesso a produtos e tecnologias
                        estrangeiras pode aumentar a competitividade da empresa
                        no mercado interno, permitindo oferecer produtos
                        diferenciados ou com preços mais competitivos.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Diluição do risco cambial: </span>
                        Algumas modalidades de
                        financiamento permitem a fixação da taxa de câmbio,
                        protegendo o importador das variações cambiais e
                        garantindo maior previsibilidade nos custos.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Oportunidade de crescimento: </span>
                        O financiamento à
                        importação possibilita o crescimento da empresa,
                        permitindo a aquisição de insumos, equipamentos e
                        tecnologias que contribuem para a expansão da produção
                        e aumento das vendas.
                    </p>

                    <div className='buttons-style inv' style={{marginTop:"30px"}}>
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>
                </div>
            </div>
        </div>

    )
}

